'use strict';

/**
 * Detail view ffor the album selection
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var ListPhotoboxView = require('../partials/list-photobox');
var ListUnusedView = require('../partials/list-unused');

var template = require('../../templates/layout/modal.hbs');

var ModalLayout = ColidoLayoutView.extend({
    template: template,

    wrapItem: false,

    collectionPhotobox: null,
    collectionUnused: null,

    regions: {
        photoboxRegion: '#region-photobox',
        unusedRegion: '#region-unused',
    },

    ui: {
        container: '.album-modal-container',
        listView: 'input[name="listView"]',
        listControl: '.listcontrol',
        countPhotobox: '#count-photobox',
        countUnused: '#count-unused',
        actionCancel: '[data-action="cancel"]',
        actionDone: '[data-action="done"]',
    },

    events: {
        'click @ui.actionCancel': 'actionCancel',
        'click @ui.actionDone': 'actionDone',
        'change @ui.listView': 'listViewChanged',
    },

    initialize: function(options) {
        ColidoLayoutView.prototype.initialize.apply(this, arguments);

        this.collectionPhotobox = this.getOption('collectionPhotobox')
            ? this.getOption('collectionPhotobox')
            : App.CollectionModule.AlbumModule.albumsPhotoboxCollection;

        this.collectionUnused = this.getOption('collectionUnused')
            ? this.getOption('collectionUnused')
            : App.CollectionModule.AlbumModule.albumsUnusedCollection;

        this.listenTo(this.collectionPhotobox, 'add remove reset sync', this.updateDomElements.bind(this));
        this.listenTo(this.collectionUnused, 'add remove reset sync', this.updateDomElements.bind(this));

        this.listenTo(this, 'attach', function() {
            this.applyFixedListControl(this.ui.listControl, this.$('.modal-body'));
        }.bind(this));
    },

    onShow: function() {
        var viewListPhotobox = new ListPhotoboxView({
            collection: this.collectionPhotobox,
        });

        var viewListUnused = new ListUnusedView({
            collection: this.collectionUnused,
        });

        this.photoboxRegion.show(viewListPhotobox);
        this.unusedRegion.show(viewListUnused);

        this.updateDomElements();
    },

    updateDomElements: function() {
        var countUnused = _.reduce(this.collectionUnused.pluck('images'), function(memo, images) {
            return memo + images.length;
        }, 0);

        this.ui.countPhotobox.html(this.collectionPhotobox.length);
        this.ui.countUnused.html(countUnused);
    },

    listViewChanged: function(event) {
        var value = this.ui.listView.filter(':checked').val();
        this.ui.container.removeClass('list-view-photobox list-view-unused');
        this.ui.container.addClass('list-view-' + value);
    },

    actionCancel: function(event) {
        this.trigger('close:modal');
    },

    actionDone: function(event) {
        var images = this.collectionUnused.getSelectedImages();
        this.collectionUnused.unsetSelectedImages();
        this.trigger('close:modal', {images: images});
    },

    /**
     * Is triggered from list item, when an imageset has been selected
     * @param {AlbumModule.ListItemPhotoboxView} childView The childview
     * @param {Array}                            images    Array of the images
     */
    onChildviewAlbumSelected: function(childView, images) {
        this.trigger('close:modal', {images: images});
    },
});

module.exports = ModalLayout;